import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import ReactApexChart from "react-apexcharts";

import { CircularProgress, useTheme } from "@mui/material";

import useLLMEvent from "../../../../hooks/user/useLLMEvent";
import { Card, CardContent } from "../../common/styled";

const ChartWrapper = styled.div`
  height: 240px;
  width: 100%;
`;
const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

const LLMEventStatsChart = ({ setCustomRangeConfirm, setTimeRange, setCustomDateRange }) => {
  const theme = useTheme();
  const { llmEventStats } = useLLMEvent();
  const [data, setData] = React.useState([
    {
      name: "LLM events",
      data: [],
    },
  ]);
  const [options, setOptions] = React.useState({
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "datetime",
      categories: [],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    chart: {
      stacked: true,
      zoom: {
        enabled: true,
      },
      type: "bar",
    },
    colors: [theme.palette.custom.yellow.opacity_80],
  });

  React.useEffect(() => {
    let categories = [];
    const llmEventDatas = [];
    if (llmEventStats?.length > 0) {
      llmEventStats.forEach((stat) => {
        categories.push(stat.key_as_string);
      });
    }
    // Remove duplicated entries
    categories = Array.from(new Set(categories));
    categories.sort();
    if (categories.length > 0) {
      categories.forEach((cate) => {
        if (null === llmEventStats || 0 === llmEventStats.length) {
          llmEventDatas.push(0);
        } else {
          let sig = llmEventStats.find((x) => x.key_as_string === cate);
          if (undefined === sig) {
            llmEventDatas.push(0);
          } else {
            llmEventDatas.push(sig.doc_count);
          }
        }
      });
    }
    setData([
      {
        name: "LLM events",
        data: llmEventDatas,
      },
    ]);
    setOptions({
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: categories,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      chart: {
        stacked: true,
        zoom: {
          enabled: true,
        },
        type: "bar",
        events: {
          zoomed: function (chartContext, { xaxis, yaxis }) {
            if (xaxis.min === undefined || xaxis.max === undefined) {
              setTimeRange("1d");
            } else {
              const from = new Date(xaxis.min);
              const to = new Date(xaxis.max);
              const month = String(from.getMonth() + 1).padStart(2, "0");
              const date = String(from.getDate()).padStart(2, "0");
              const year = String(from.getFullYear());
              const hour = String(from.getHours()).padStart(2, "0");
              const minute = String(from.getMinutes()).padStart(2, "0");
              const second = String(from.getSeconds()).padStart(2, "0");
              const _month = String(to.getMonth() + 1).padStart(2, "0");
              const _date = String(to.getDate()).padStart(2, "0");
              const _year = String(to.getFullYear());
              const _hour = String(to.getHours()).padStart(2, "0");
              const _minute = String(to.getMinutes()).padStart(2, "0");
              const _second = String(to.getSeconds()).padStart(2, "0");
              setTimeRange("custom");
              setCustomRangeConfirm(true);
              setCustomDateRange([
                year + "-" + month + "-" + date + "T" + hour + ":" + minute + ":" + second,
                _year + "-" + _month + "-" + _date + "T" + _hour + ":" + _minute + ":" + _second,
              ]);
            }
          },
        },
      },
      colors: [theme.palette.custom.yellow.opacity_80],
    });
  }, [llmEventStats, setTimeRange, setCustomDateRange, setCustomRangeConfirm, theme.palette.custom.yellow.opacity_80]);

  return (
    <Card sx={{ mt: 4, boxShadow: "none" }}>
      <CardContent sx={{ background: "white", borderRadius: "8px" }}>
        <ChartWrapper>
          {null === llmEventStats ? (
            <Root>
              <CircularProgress color="success" />
            </Root>
          ) : (
            <ReactApexChart color="success" options={options} series={data} type="bar" height="250" />
          )}
        </ChartWrapper>
      </CardContent>
    </Card>
  );
};

export default withTheme(LLMEventStatsChart);
